// extracted by mini-css-extract-plugin
export var marginNegative = "_7c-5 _7c-3 _7c-1";
export var marginPositive = "_7c-4 _7c-3 _7c-1";
export var modalContent = "_7c-6";
export var samplesTable = "_7c-8";
export var samplesTableContainer = "_7c-7";
export var statBox = "_7c-a";
export var tableCell = "_7c-1";
export var tableCellCenter = "_7c-2 _7c-1";
export var tableCellRight = "_7c-3 _7c-1";
export var tableHeader = "_7c-0";
export var trackingNumber = "_7c-9";